<template>
  <div>
    <div class="mb-0 pb-0">
      <p class=""><b>{{ $t('contactInfo.title') }}</b></p>

      <!-- Skeleton Loader (mientras no hay datos) -->
      <div v-if="!infoAgente || !infoAgente.Nombre" class="d-flex mb-0 pb-0">
        <!-- Avatar skeleton -->
        <div class="skeleton-avatar mr-3"></div>

        <!-- Nombre y teléfono skeleton -->
        <div class="flex-grow-1">
          <div class="skeleton-line w-75 mb-2"></div>
          <div class="skeleton-line w-50"></div>
        </div>
      </div>

      <!-- Contenido real (cuando hay datos) -->
      <div v-else class="d-flex mb-0 pb-0">
        <!-- Avatar con imagen o ícono por defecto -->
        <div v-if="isLoadingImages" class="skeleton-avatar mr-3"></div>
        <img
          v-else-if="infoAgente.img_url"
          class="ml-0 contact-agent-avatar"
          :src="infoAgente.img_url"
          :alt="infoAgente.Nombre || $t('agents.heading')"
          width="50"
          height="50"
          loading="lazy"
          decoding="async"
        />
        <div v-else class="mr-2" style="width: 50px; height: 50px">
          <div class="d-flex align-items-center justify-content-center" style="width: 100%; height: 100%; border-radius: 50%; background-color: #f8d7da; color: #721c24;">
            <i class="fa-solid fa-user" style="font-size: 1.5rem"></i>
          </div>
        </div>

        <!-- Información del contacto -->
        <div class="ml-2 d-flex flex-column justify-content-center flex-grow-1">
          <div class="d-flex justify-content-between align-items-center mb-0">
            <span>{{ infoAgente.Nombre }}</span>
            <span class="text-secondary">
              {{ formatPhoneNumber(infoAgente.Celular) }}
            </span>
          </div>

          <div v-if="infoAgente.Email" class="">
            <span class="text-secondary">
              <i class="fa-solid fa-envelope pr-2"></i>{{ infoAgente.Email }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactInfoCard",
  props: {
    infoAgente: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      isLoadingImages: true
    };
  },
  mounted() {
    if (this.infoAgente?.img_url) {
      this.preloadImage();
    } else {
      this.isLoadingImages = false;
    }
  },
  watch: {
    infoAgente: {
      handler(newVal) {
        if (newVal?.img_url) {
          this.preloadImage();
        } else {
          this.isLoadingImages = false;
        }
      },
      immediate: true
    }
  },
  methods: {
    formatPhoneNumber(phone) {
      if (!phone) return "";

      const digits = phone.toString().replace(/\D/g, "");

      const countryCode = digits.slice(0, 3); // 505
      const localNumber = digits.slice(3);    // 55047184

      const formattedLocal = localNumber.match(/.{1,4}/g)?.join(" ") || localNumber;

      return `+${countryCode} ${formattedLocal}`;
    },
    preloadImage() {
      this.isLoadingImages = true;
      const img = new Image();
      img.onload = () => {
        this.isLoadingImages = false;
      };
      img.onerror = () => {
        this.isLoadingImages = false;
      };
      img.src = this.infoAgente.img_url;
    }
  },
};
</script>

<style scoped>
/* Skeleton loader styles */
.skeleton-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: linear-gradient(90deg, #f0f0f0 25%, var(--primary-transparent) 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

.contact-agent-avatar {
  flex: 0 0 50px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: cover;
}

.skeleton-line {
  height: 16px;
  background: linear-gradient(90deg, #f0f0f0 25%, var(--primary-transparent) 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  border-radius: 4px;
  animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

/* Estilos generales (opcional, ya tenías algunos) */
label {
  display: block;
  margin-bottom: 0.5em;
}
input,
select {
  width: 100%;
  padding: 0.5em;
  margin-bottom: 1em;
}
button {
  margin-top: 1em;
}
</style>
